var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { v4 as uuidv4 } from 'uuid';
import ApiError from '~/errors/api';
import getURLParam from '~/utils/getURLParam';
import { keysToCamel } from '~/utils/toCamelCase';
import { keysToSnake } from '~/utils/toSnakeCase';
export const Websocket = class {
    constructor(userId, organization, navigate, setIsWebsocketReady) {
        this.callbacks = {};
        this.eventsFailedByAuthorization = [];
        this.isReauthorizing = false;
        this.parts = {};
        this.onOpen = () => {
            window.debugLogger('WebSocket connection established.');
            this.setIsWebsocketReady(true);
        };
        this.onClose = () => {
            window.debugLogger('Websocket disconnected.');
        };
        this.onMessage = (event) => {
            const data = keysToCamel(JSON.parse(event.data));
            if (!this.callbacks[data.eventId])
                return;
            try {
                if (data.statusCode === 206)
                    return this.partCallback(data);
                if (data.statusCode === 403)
                    return this.unauthorizedEventCallback();
                this.callbacks[data.eventId].callback(data, this.navigate);
                delete this.callbacks[data.eventId];
            }
            catch (err) {
                console.error(err);
                this.callbacks[data.eventId].callback(Object.assign(Object.assign({}, data), { statusCode: 500, payload: err }));
            }
        };
        this.onError = (event) => {
            window.routeToErrorPage(new ApiError(JSON.stringify(event)));
        };
        this.send = (eventType, payload, callback, eventId) => __awaiter(this, void 0, void 0, function* () {
            if (this.ws.readyState !== 1) {
                setTimeout(() => this.send(eventType, payload, callback, eventId), 100);
                return;
            }
            payload = Object.assign(Object.assign({}, payload), { organizationId: this.organization.id });
            eventId = eventId || uuidv4();
            yield this.ws.send(JSON.stringify(keysToSnake({ eventType, eventId, payload }, ['metadata', 'advancedFilters'])));
            this.callbacks[eventId] = { eventId, payload, callback };
        });
        this.partCallback = (data) => {
            if (!this.parts[data.eventId]) {
                this.parts[data.eventId] = Array(data.partCount).fill(null);
            }
            if (data.partIndex === undefined)
                return;
            this.parts[data.eventId][data.partIndex] = data.payload;
            if (this.parts[data.eventId].every(part => part !== null)) {
                const completeParts = this.parts[data.eventId].join('');
                const payload = keysToCamel(JSON.parse(completeParts));
                this.callbacks[data.eventId].callback(Object.assign(Object.assign({}, data), { statusCode: 200, payload }), this.navigate);
                delete this.callbacks[data.eventId];
            }
        };
        this.unauthorizedEventCallback = () => {
            console.warn('Received Unauthorized response from WebSocket.');
            window.routeToErrorPage(new Error('Received Unauthorized response from WebSocket.'));
        };
        this.retryFailedEvents = () => {
            for (const socketRequest of this.eventsFailedByAuthorization) {
                this.send(socketRequest.eventType, socketRequest.payload, socketRequest.callback, socketRequest.eventId);
            }
            this.eventsFailedByAuthorization = [];
        };
        this.close = () => {
            this.ws.close();
        };
        this.userId = userId;
        this.organization = organization;
        this.navigate = navigate;
        this.setIsWebsocketReady = setIsWebsocketReady;
        this.isDevMode = getURLParam('DEV_MODE') !== null;
        const ws = new WebSocket(window.RG_CONFIG.WEB_SOCKET_URL);
        ws.onopen = this.onOpen;
        ws.onclose = this.onClose;
        ws.onmessage = this.onMessage;
        ws.onerror = this.onError;
        this.ws = ws;
    }
};
